const socketResponse = (function() {

    // ATRIBUTOS PRIVADOS
    let socket = null;
    let socketResponseListeners = {     // Es la lista de todas las sucripciones activas, entre otras cosas se utiliza para no duplicar eventos de suscripcion (.on)
        SEND_MESSAGE_RESPONSE: false,
        NOTIFY_UPDATED_ROOM: false
    }

    // METODOS PRIVADOS
    function socketErrors(errorCode, errorData) {

        switch(errorCode) {
            case 'DISCONNECTED_SOCKET':
                console.error('EL SOCKET NO ESTA CONECTADO');
                break;

            case 'RESPONSE_ERROR':
                console.error('ERROR EN LA RESPUESTA ' + errorData);
                break;
        }

    }

    // METODOS PUBLICOS
    return {

        // OPCIONES DEL RESPONSE ================================================================================================== //
        disconnectListeners: function() {
            socketResponseListeners = _.mapValues(socketResponseListeners, function () {
                return false;
            });
        },

        // SERVICIOS DEL SOCKET =================================================================================================== //

        // CHAT =================================================================================================================== //
        sendMessage: function() {

            socket = socketRequest.getSocket();

            if (socket && !socketResponseListeners.SEND_MESSAGE_RESPONSE) {
                socketResponseListeners.SEND_MESSAGE_RESPONSE = true;
                socket.on(SocketEvents.SEND_MESSAGE_RESPONSE(), function(data) {
                    if (data.success) {
                        chatScreenController.updateRoomMessageData(data);
                    } else {
                        socketErrors('RESPONSE_ERROR', {responseName: 'SEND_MESSAGE_RESPONSE', responseData: data});
                    }
                })
            } else {
                socketErrors(socket ? 'DUPLICATE_SUSCRIPTION_RESPONSE' : 'DISCONNECTED_SOCKET');
            }

        },

        notifyUpdatedRoom: function() {

            socket = socketRequest.getSocket();

            if (socket && !socketResponseListeners.NOTIFY_UPDATED_ROOM) {
                socketResponseListeners.NOTIFY_UPDATED_ROOM = true;
                socket.on(SocketEvents.NOTIFY_UPDATED_ROOM(), function (data) {
                    if (data.success) {
                        chatScreenController.updateRoomMessagesStatus(data);
                    } else {
                        socketErrors('RESPONSE_ERROR', {responseName: 'NOTIFY_UPDATED_ROOM', responseData: data});
                    }
                });
            } else {
                socketErrors(socket ? 'DUPLICATE_SUSCRIPTION_RESPONSE' : 'DISCONNECTED_SOCKET');
            }
        }

        // CHART ================================================================================================================== //
        // JUEGO ================================================================================================================== //
        // DOCUMENTACION ========================================================================================================== //

    }

})();